import {Condition} from '../contracts/report-definition.types';

/** Candidate ids for the Remaining work picker. They are not wire values: each one stands for a
 * whole comparison (operator plus threshold), because "has work left" is a comparison, not a value.
 * `remainingWorkWrite` turns one into the condition it means. */
export const REMAINING_WORK_YES = 'YES';
export const REMAINING_WORK_NO = 'NO';

export function remainingWorkWrite(pickedId: string): {operator: string; values: string[]} {
	return pickedId === REMAINING_WORK_YES ? {operator: 'GREATER', values: ['0']} : {operator: 'LESS_OR_EQUAL', values: ['0']};
}

/** Which candidate a stored condition corresponds to, or nothing when it is a comparison this
 * control cannot express (an agent-written "more than 8 hours left", say). Returning an empty
 * selection there is deliberate: the tile still summarises the real comparison, and picking a
 * candidate replaces it rather than adding a second, contradictory value. */
export function remainingWorkSelection(condition: Condition): string[] {
	if (condition.values.length !== 1 || condition.values[0] !== '0') {
		return [];
	}
	if (condition.operator === 'GREATER') {
		return [REMAINING_WORK_YES];
	}
	if (condition.operator === 'LESS_OR_EQUAL') {
		return [REMAINING_WORK_NO];
	}
	return [];
}
